var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cargo-crud-checklist-id',{attrs:{"model":_vm.model,"modelstate":_vm.modelstate,"readonly":_vm.readonly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }